import React, { memo } from 'react';
import { Box, Flex, Spacer, Text } from '@chakra-ui/react';
import FormatNumber from './FormatNumber';

const maskValue = (value: string | number , maskChar: string = 'X'): string => {
  const stringValue = typeof value === 'number' ? value.toString() : value;
  return stringValue.replace(/[a-zA-Z0-9]/g, maskChar);
};

const StatCard = ({title, stats, hasMask = false}: StatsProps) => {

  return (
    <Box p="xl" borderWidth="1px" borderRadius="lg" overflow="hidden" >
      <Flex flexDirection="row" justifyContent="space-between" alignItems={'center'}>
        <Box>
          <Text fontSize="l" fontWeight="bold">
            {hasMask ? maskValue(title) : title}
          </Text>
        </Box>
        <Spacer />
      </Flex>

      <Flex direction={'row'} justifyContent={'space-between'} >
        {
          stats.map((stat, index) => (
              <Box key={index}>
                <Text textAlign={stat.textAlign} color="neutral.600">
                  { hasMask ? maskValue(stat.label) : stat.label}
                </Text>

                  { stat.hasFormat && stat.value >= 0 ?  (
                    <FormatNumber value={stat.value} style="currency"
                                  currency="USD" textProps={{fontSize: '3xl', textAlign: 'right'}}/>
                  ) : (
                    <Text fontSize="3xl" > {hasMask && stat.value ? maskValue(stat.value) : stat.value}</Text>
                  )
                  }

              </Box>
            )
          )
        }
      </Flex>
    </Box>
  )
}

export default memo(StatCard)
